// extracted by mini-css-extract-plugin
export default {"sib-rows-stack":"QSGngSR9m4m5Rnmxl9FC","sib-columns-stack":"H14q0zi06xR2AUSAR7aG"};